import "../styles/globals.css";
import { Provider } from "react-redux";
import { useStore } from "../redux/store";
import { useEffect } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import Router from "next/router";
import NProgress from "nprogress"; //nprogress module
import "nprogress/nprogress.css"; //styles of nprogress
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import theme from "../utils/theme";
import Auth from "../auth";

Router.events.on("routeChangeStart", () => NProgress.start());
Router.events.on("routeChangeComplete", () => NProgress.done());
Router.events.on("routeChangeError", () => NProgress.done());

function MyApp({ Component, pageProps }) {
  const store = useStore(pageProps.initialReduxState);
  useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector("#jss-server-side");
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Auth>
          <ReactNotification />
          <Component {...pageProps} />
        </Auth>
      </Provider>
    </ThemeProvider>
  );
}

export default MyApp;
